import { useLayoutEffect, useRef } from 'react';
import { flushSync } from 'react-dom';
import { createRoot } from 'react-dom/client';
import { HoiPoiProvider, Tooltip } from '@Sage/hoi-poi-ui';

import { theme } from 'lib/styles/theme';

const HOST_TAG = 'w5-cell-checkbox-tooltip';

function defineHostElement() {
    if (typeof customElements === 'undefined' || customElements.get(HOST_TAG)) return;

    customElements.define(
        HOST_TAG,
        class extends HTMLElement {
            disconnectedCallback() {
                this.__tooltipRoot?.unmount();
                this.__tooltipRoot = null;
            }
        },
    );
}

function DisabledCheckboxTooltip({ content, triggerEl }) {
    const wrapRef = useRef(null);

    useLayoutEffect(() => {
        const trigger = wrapRef.current?.querySelector('.w5-cell-checkbox-tooltip__trigger');
        if (trigger && triggerEl.parentNode !== trigger) {
            trigger.appendChild(triggerEl);
        }
    }, [triggerEl]);

    return (
        <HoiPoiProvider theme={theme}>
            <span ref={wrapRef} className="w5-cell-checkbox-tooltip__wrap">
                <Tooltip content={content} placement="top">
                    <span
                        className="w5-cell-checkbox-tooltip__trigger"
                        style={{ display: 'inline-flex', alignItems: 'center' }}
                    />
                </Tooltip>
            </span>
        </HoiPoiProvider>
    );
}

export function wrapCellCheckboxWithTooltip(triggerEl, content) {
    if (!content || !triggerEl) return triggerEl;

    defineHostElement();

    const host = document.createElement(HOST_TAG);
    host.className = 'w5-cell-checkbox-tooltip';
    host.style.display = 'inline-flex';
    host.style.alignItems = 'center';

    const root = createRoot(host);
    host.__tooltipRoot = root;

    flushSync(() => {
        root.render(<DisabledCheckboxTooltip content={content} triggerEl={triggerEl} />);
    });

    return host;
}
